import { Component, OnInit,Input, Output, EventEmitter } from '@angular/core';
import { timer } from 'rxjs/internal/observable/timer';
import { Subscription } from 'rxjs/internal/Subscription';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {
  display: any;
  public timerInterval: any;
  @Output() timerCompleted = new EventEmitter<boolean>();

  constructor() {
  }
  ngOnInit(): void {
    
  }

  start() {
    this.timer(1);
  }
  stop() {
    clearInterval(this.timerInterval);
  }

  timer(minute: number) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.timerCompleted.emit(true);
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }
  
}

